module.exports = __webpack_public_path__ + "img/video.ddea484b.png";